import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verification-landing',
  standalone: false,
  templateUrl: './verification-landing.component.html',
  styleUrl: './verification-landing.component.scss'
})
export class VerificationLandingComponent implements OnInit {

  formGroup: FormGroup;
  types: any[] = [
    {
      value: 'ASSESSMENT',
      title: 'IGR Assessment'
    },
    {
      value: 'LGA_IDENTIFICATION',
      title: 'LGA Identification'
    },
    {
      value: 'STREET_NAMING',
      title: 'Street Naming'
    },
    {
      value: 'BIRTH_REGISTRATION',
      title: 'Birth Registration'
    },
    {
      value: 'MARRIAGE_REGISTRATION',
      title: 'Marriage Registration'
    },
    {
      value: 'DEATH_REGISTRATION',
      title: 'Death Registration'
    },
    {
      value: 'REVALIDATION',
      title: 'Revalidation'
    },
    {
      value: 'PAYMENT',
      title: 'Payment'
    },

  ];
  

  constructor(private formBuilder: FormBuilder, private router: Router) {

  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      verificationType: [null, Validators.required],
      value: [null, Validators.required],
    })
  }

  submit() {
    const values = this.formGroup.getRawValue()
    this.router.navigate(['/verification-view'], {
      queryParams: { applicationid: values.value, qrcodetype: values.verificationType }
    })
  }
}
